import React from "react";

import { AdministrationCard } from "@common/components/AdministrationCard/AdministrationCard";
import Button from "@common/components/Button/Button";
import PageWrap from "@common/components/PageWrap/PageWrap";
import { Spinner } from "@common/components/Spinner/Spinner";
import { isFreePlan } from "@common/util/workspaceUtil";
import { useAppContext } from "@main/context/App/App.context";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { useShakingAnimation } from "@main/context/ShakingAnimation/ShakingAnimationContext";

import ImportCard from "../../components/AppsCards/ImportCard";
import { UserFeedbackIntegrationsCard } from "../../components/AppsCards/UserFeedbackIntegrationsCard";
import NoAppsView from "../../components/NoAppsView";
import useAppsFeedbackViewConsumer from "../../consumers/useAppsFeedbackViewConsumer";

export default function AppsFeedbackView(): JSX.Element {
  const { loading: appsLoading } = useAppContext();
  const { selectedWorkspace } = useAppSelectionContext();
  const { triggerShake } = useShakingAnimation();

  const { loading, disconnectIntegration, allApps, preSelectedIntegrationType, exportTickets, localSelectedApp } =
    useAppsFeedbackViewConsumer();

  if (!appsLoading && allApps.length === 0) {
    return (
      <PageWrap style={{ marginTop: "4rem" }}>
        <NoAppsView selectedWorkspace={selectedWorkspace} />
      </PageWrap>
    );
  }

  if (!localSelectedApp) {
    return <Spinner />;
  }

  const localLoading = appsLoading || loading;

  return (
    <PageWrap style={{ marginTop: "4rem" }}>
      <UserFeedbackIntegrationsCard
        app={localSelectedApp}
        disabled={!localSelectedApp.active}
        loading={localLoading}
        disconnectIntegration={disconnectIntegration}
        preSelectedIntegrationType={preSelectedIntegrationType}
        tooltip={{
          text: !localSelectedApp.active ? "Integrations can be added on active apps only" : "",
        }}
      />
      {!Boolean(localSelectedApp?.is_sample) && (
        <ImportCard
          app={localSelectedApp}
          disabled={localLoading}
        />
      )}
      <AdministrationCard
        title="Export tickets"
        subtitle="Export all feedback tickets into a .csv file. Succesfully exported file will be forwarded to your email."
        isEmpty
        topLeftAccessory={
          <Button
            size="small"
            onClick={() => (localSelectedApp?.is_sample ? triggerShake("AddAppButton") : exportTickets())}
            disabled={isFreePlan(selectedWorkspace)}
            tooltip={{
              text: "Upgrade your plan to download tickets",
              disabled: !isFreePlan(selectedWorkspace),
              position: "top",
            }}
          >
            Download
          </Button>
        }
      />
    </PageWrap>
  );
}
